import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.wrapper = {
      width: '100%',
      mt: [0, '-12px'],
    };

    this.button = {
      width: '100%',
      height: '58px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: (t) => `1px solid ${t.colors.gray}`,
    };

    this.text = {
      variant: 'text.label.1',
    };

    this.icon = {
      color: 'text',
      width: '20px',
      ml: 2,
    };

    this.modal = {
      minHeight: '400px',
      height: '75vh',
      maxHeight: '1000px',
      width: ['100%', '85vw'],
      maxWidth: '1280px',
      overflowY: 'auto',
      // wrapper
      '#jtbcustomizer .jtbc-wrapper': {
        display: 'flex',
        flexDirection: ['column', 'row'],
      },
      '#jtbcustomizer .jtbc-menu-wrapper .jtbc-menu-container': {
        background: 'white',
      },
      '#jtbcustomizer .jtbc-info-wrapper__mobile': {
        textAlign: 'center',
        padding: '15px',
      },
      '#jtbcustomizer .jtbc-menu-element': {
        marginBottom: '0px !important',
      },
      '#jtbcustomizer .jtbc-menu-element.approval_check': {
        marginTop: ['14px!important', '20px!important'],
      },
      // all text
      '*': {
        fontFamily:
          '"Fellix", system-ui, -apple-system, BlinkMacSystemFont, sans-serif !important',
      },
      // heading
      '#jtbcustomizer .jtbc-info-wrapper .jtbc-product-title': {
        variant: 'text.h2',
        fontFamily: 'Reckless Neue !important',
        textTransform: 'capitalize !important',
      },
      // price
      '#jtbcustomizer .jtbc-info-wrapper .jtbc-product-price-container .jtbc-product-charge-description':
        {
          variant: 'text.base',
        },
      // disclaimer
      '#jtbcustomizer .jtbc-disclaimer': {
        variant: 'text.base',
        fontSize: [3, 4],
      },
      '.jtbc-hint': {
        mt: '8px !important',
      },

      /// menu panel
      '#jtbcustomizer .jtbc-menu-panel': {
        marginTop: '0 !important',
        paddingTop: '0 !important',
        width: 'unset !important',
        flex: '1 !important',
      },

      // menu wrapper
      '#jtbcustomizer .jtbc-menu-wrapper .jtbc-menu-container[data-component-mode="accordion"] .jtbc-menu-tab-pane.jtbc-menu-tab-pane--active[aria-hidden="false"]':
        {
          paddingTop: 0,
        },

      // Choose type heading
      '#jtbcustomizer .jtbc-decision-selector .jtbc-menu-element__label': {
        variant: 'text.label.1',
        color: '#222222',
        mb: '4px',
      },

      // Choose type radio buttons
      '#jtbcustomizer .jtbc-radio-buttons-group .jtbc-radio-button label': {
        textTransform: 'capitalize !important',
      },

      '#jtbcustomizer .jtbc-radio-buttons-group .jtbc-radio-button label .jtbc-radio-button__checkmark':
        {
          border: (t) => `1px solid ${t.colors.gray}`, // #E8E8E8
          borderRadius: '44px',
          transition: 'all 0.15s ease-in-out',
        },

      // radio button hover
      '#jtbcustomizer .jtbc-radio-buttons-group .jtbc-radio-button label input[type=radio]:hover ~ .jtbc-radio-button__checkmark':
        {
          border: (t) => `1px solid ${t.colors.mediumDarkGray}`, // #8C8C8D
        },
      // radio button selected
      '#jtbcustomizer .jtbc-radio-buttons-group .jtbc-radio-button label input[type=radio]:checked ~ .jtbc-radio-button__checkmark':
        {
          border: (t) => `1px solid ${t.colors.text}`, // #222222
        },

      // initials / icon label
      '#jtbcustomizer .jtbc-menu-element .jtbc-menu-element__label': {
        variant: 'text.label.1',
        color: '#222222',
        position: 'relative',
      },
      // initials sub label
      '#jtbcustomizer .jtbc-input-text label': {
        position: 'relative',
        top: '26px',
        left: '20px',
        zIndex: 9998,
        color: '#222222',
        width: '80%',
      },
      // initials input
      '.jtbc-input-text': {
        width: '100%',
        display: 'block',
        mb: '0px !important',
      },
      '#jtbcustomizer .jtbc-input-text input': {
        borderRadius: '50px',
        width: '98%',
        height: '44px',
        pl: '20px',
        pt: '18px',
        fontSize: '15px',
        color: '#222222',
      },
      '#jtbcustomizer .jtbc-input-text__input': {
        border: '1px solid #C6C6C7',
        transition: 'all 0.15s ease-in-out',
      },
      '#jtbcustomizer .jtbc-input-text__input:hover': {
        border: '1px solid #8C8C8D',
      },
      '#jtbcustomizer .jtbc-input-text__input:focus': {
        border: '1px solid #222222',
      },

      // ?
      '#jtbcustomizer .jtbc-menu-element-optgroup-selection': {
        mb: 0,
      },

      // dropdown mobile
      '#jtbcustomizer .jtbc-select-box .jtbc-selectbox-hide-select.jtbc-selectbox-is-native':
        {
          border: 'none !important',
        },

      // dropdown sub label
      '#jtbcustomizer .jtbc-menu-element__sub_label': {
        position: 'relative',
        top: '26px',
        left: '20px',
        zIndex: 9998,
        color: '#222222',
        width: '80%',
      },

      // dropdown
      '#jtbcustomizer .jtbc-select-box': {
        width: '100%',
      },
      '#jtbcustomizer .jtbc-select-box .jtbc-selectbox': {
        borderRadius: '60px',
        border: '1px solid #C6C6C7',
        mb: '16px',
        mt: 0,
        width: '98%',
        height: '44px',
        transition: 'all 0.15s ease-in-out',
        pl: '20px',
        pt: '14px',
        pb: '16px',
      },
      '#jtbcustomizer .jtbc-select-box .jtbc-selectbox .label': {
        ml: '0px',
        mt: '0px',
        fontSize: '15px',
        color: '#222222',
      },
      // dropdown hover
      '#jtbcustomizer .jtbc-select-box .jtbc-selectbox-hover .jtbc-selectbox': {
        border: '1px solid #8C8C8D',
      },
      // dropdown open
      '#jtbcustomizer .jtbc-select-box .jtbc-selectbox-open': {
        zIndex: 9995,
      },
      '#jtbcustomizer .jtbc-select-box .jtbc-selectbox-open .jtbc-selectbox': {
        border: '1px solid #222222',
        zIndex: 9995,
      },
      // dropdown drawer
      '#jtbcustomizer .jtbc-select-box .jtbc-selectbox-open .jtbc-selectbox-items':
        {
          mt: '8px',
          border: '1px solid #E8E8E8',
        },
      // dropdown drawer hover
      '#jtbcustomizer .jtbc-select-box .jtbc-selectbox-items li': {
        fontSize: '15px',
        color: '#222222',
      },
      // dropdown drawer hover
      '#jtbcustomizer .jtbc-select-box .jtbc-selectbox-items li:hover': {
        border: '1px solid #8C8C8D',
        backgroundColor: 'transparent',
        color: '#222222',
      },
      // dropdown drawer selected
      '#jtbcustomizer .jtbc-select-box .jtbc-selectbox-items li.selected': {
        border: '1px solid #222222',
        backgroundColor: 'transparent',
        color: '#222222',
      },

      // icon squares
      '#jtbcustomizer .jtbc-attribute-selector .jtbc-attribute-item': {
        border: (t) => `1px solid ${t.colors.gray}`, // #E8E8E8
      },
      // icon squares hover
      '#jtbcustomizer .jtbc-attribute-selector .jtbc-attribute-item.jtbc-attribute-item__square:hover':
        {
          border: (t) => `1px solid ${t.colors.mediumDarkGray}`, // #8C8C8D
          transform: 'scale(1)',
        },

      // icon squares selected
      '#jtbcustomizer .jtbc-attribute-selector .jtbc-attribute-item.jtbc--selected':
        {
          boxShadow: 'none',
          border: (t) => `1px solid ${t.colors.text}`, // #222222
        },

      // prev/next buttons wrapper
      '#jtbcustomizer .jtbc-pagination-wrapper': {
        justifyContent: 'center',
        mt: '5px',
        mr: '10px',
      },
      // prev/next buttons
      '#jtbcustomizer .jtbc-pagination-wrapper .jtbc-pagination-button': {
        border: '1px solid #E8E8E8',
        borderRadius: '50%',
        color: '#222222',
        fontWeight: '800',
        transition: 'all 0.15s ease-in-out',
        fontSize: '20px',
      },
      // prev/next buttons hover
      '#jtbcustomizer .jtbc-pagination-wrapper .jtbc-pagination-button:hover': {
        border: '1px solid #8C8C8D',
        backgroundColor: 'transparent',
      },
      // prev/next buttons disabled
      '#jtbcustomizer .jtbc-pagination-wrapper .jtbc-pagination-button.jtbc-pagination-button__disabled':
        {
          color: '#C6C6C7',
          border: '1px solid #E8E8E8',
        },
      // prev button
      '#jtbcustomizer .jtbc-pagination-wrapper .jtbc-pagination-button.jtbc-pagination-button__prev':
        {
          mr: '8px',
          pr: '2px',
          pb: '1px',
        },
      '#jtbcustomizer .jtbc-pagination-wrapper .jtbc-pagination-button.jtbc-pagination-button__next':
        {
          pl: '2px',
          pb: '1px',
        },

      // qty wrapper
      '#jtbcustomizer .jtbc-actions .jtbc-quantity': {
        border: 'none',
        justifyContent: 'flex-start',
        mr: '24px',
        pl: '16px',
        minWidth: '110px',
      },
      // qty buttons outer
      '#jtbcustomizer .jtbc-actions .jtbc-quantity .jtbc-quantity-spinner': {
        borderRadius: '50%',
        width: '32px',
        height: '32px',
        transition: 'all 0.15s ease-in-out',
        lineHeight: '26px',
      },
      // qty buttons inner
      '#jtbcustomizer .jtbc-button__symbol': {
        border: '1px solid #E8E8E8',
        borderRadius: '50%',
        width: '32px',
        height: '32px',
        transition: 'all 0.15s ease-in-out',
        fontSize: '24px',
      },
      // qty buttons outer before
      '#jtbcustomizer .jtbc-actions .jtbc-quantity .jtbc-quantity-spinner:before':
        {
          height: '0px',
          width: '0px',
        },
      // qty buttons inner before
      '#jtbcustomizer .jtbc-button__symbol:before': {
        height: '0px',
        width: '0px',
      },
      // qty buttons outer after
      '#jtbcustomizer .jtbc-actions .jtbc-quantity .jtbc-quantity-spinner:after':
        {
          height: '0px',
          width: '0px',
        },
      // qty buttons inner after
      '#jtbcustomizer .jtbc-button__symbol:after': {
        height: '0px',
        width: '0px',
      },
      // qty buttons outer hover
      '#jtbcustomizer .jtbc-actions .jtbc-quantity .jtbc-quantity-spinner:hover':
        {
          backgroundColor: 'transparent',
        },
      // qty buttons inner hover
      '#jtbcustomizer .jtbc-button__symbol:hover': {
        border: '1px solid #8C8C8D',
      },

      // ATC
      '#jtbcustomizer .jtbc-actions .jtbc-cart-button': {
        borderRadius: '22px',
        pt: '12px',
        transition: 'all 0.2s ease-in-out',
        height: '42px',
        alignSelf: 'center',
        width: '100%',
        mr: '28px',
        fontSize: '0px !important',
        fontWeight: 500,
        textTransform: 'none !important',
      },

      '#jtbcustomizer .jtbc-actions .jtbc-cart-button:after': {
        fontFamily:
          '"Fellix", system-ui, -apple-system, BlinkMacSystemFont, sans-serif !important',
        fontSize: '15px !important',
        content: '"Add to Bag"',
        color: 'white',
        bg: 'transparent',
        position: 'relative',
        top: '0px',
        left: '0px',
      },

      // ATC hover
      '#jtbcustomizer .jtbc-actions .jtbc-cart-button:hover': {
        bg: 'darkGray',
        color: 'white',
      },
      // ATC before
      '#jtbcustomizer .jtbc-button:before': {
        height: '0px',
        width: '0px',
        color: 'black',
      },
      // ATC after
      '#jtbcustomizer .jtbc-button:after': {
        height: '0px',
        width: '0px',
        color: 'black',
      },

      // secondary actions panel
      '#jtbcustomizer .jtbc-actions.jtbc-actions__secondary.jtbc-actions__secondary__mobile':
        {
          display: 'flex',
          justifyContent: 'flex-start',
          pl: '16px',
          pr: '28px',
        },
      '#jtbcustomizer .jtbc-actions.jtbc-actions__secondary': {
        width: '100%',
      },
      '#jtbcustomizer .jtbc-actions.jtbc-actions__secondary .jtbc-actions-left, #jtbcustomizer .jtbc-actions.jtbc-actions__secondary .jtbc-actions-right':
        {
          mb: '24px',
        },
      '#jtbcustomizer .jtbc-actions.jtbc-actions__secondary .jtbc-actions-left':
        {
          width: 'calc(100% - 46px)',
          justifyContent: 'space-between',
        },

      // snapshots button
      '#jtbcustomizer .jtbc-button': {
        variant: 'text.link',
        border: 'none !important',
        backgroundColor: 'transparent',
        color: '#222222',
      },
      ' #jtbcustomizer .jtbc-button:hover, #jtbcustomizer .jtbc-button:focus': {
        backgroundColor: 'transparent',
        color: '#222222',
        borderColor: '#222222',
      },
      '#jtbcustomizer .jtbc-actions.jtbc-actions__secondary .jtbc-camera-button':
        {
          pt: '14px',
          pl: '0px',
          pr: '0px',
          mr: '8px',
          width: '18px',
        },
      '#jtbcustomizer .jtbc-actions.jtbc-actions__secondary .jtbc-camera-button .jtbc-icon-camera':
        {
          fill: '#222222',
        },
      '#jtbcustomizer .jtbc-actions.jtbc-actions__secondary .jtbc-camera-button:hover .jtbc-icon-camera':
        {
          fill: '#444444',
        },
      '#jtbcustomizer .jtbc-actions.jtbc-actions__secondary .jtbc-camera-button:before':
        {
          height: '0px',
          width: '0px',
        },
      '#jtbcustomizer .jtbc-actions.jtbc-actions__secondary .jtbc-camera-button:after':
        {
          height: '0px',
          width: '0px',
        },
      '#jtbcustomizer .jtbc-button, .css-14n432b-Box #jtbcustomizer .jtbc-button':
        {
          lineHeight: '18px',
          backgroundColor: 'transparent',
          color: '#222222',
          borderColor: ' #222222',
          px: 0,
          pb: 0,
          pt: '14px',
          height: '30px',
        },
      '#jtbcustomizer .jtbc-button.jtbc-user-content-upload-button, .css-14n432b-Box #jtbcustomizer .jtbc-button.jtbc-user-content-upload-button, #jtbcustomizer .jtbc-menu-element[data-element-code="upload_logo"] .jtbc-button':
        {
          pt: 0,
          height: 'auto',
          marginTop: '-12px',
        },
      '#jtbcustomizer .jtbc-menu-element[data-element-code="upload_logo"] .jtbc-button.jtbc-user-content-startover-button':
        {
          marginRight: '8px',
        },
      '#jtbcustomizer .jtbc-menu-element[data-element-code="upload_logo"] .jtbc-user-content-uploaded-container .jtbc-menu-element__sub_label':
        {
          position: 'relative',
          top: 0,
          left: 0,
          marginTop: '12px',
        },

      // snpashots modal
      '#jtbcustomizer .jtbc-popover': {
        fontSize: '15px',
        fontWeight: 500,
      },
      // snapshot modal header
      '#jtbcustomizer .jtbc-popover-header': {
        border: '1px solid #E8E8E8',
      },
      '#jtbcustomizer .jtbc-popover-header .jtbc-popover-title': {
        textTransform: 'capitalize',
        fontSize: '17px',
        fontWeight: 500,
      },
      '#jtbcustomizer .jtbc-popover-header .jtbc-popover-close-icon': {
        height: '14px',
        width: '14px',
        alignSelf: 'center',
        top: '18px',
        right: '18px',
      },
      // snapshot modal body
      '#jtbcustomizer .jtbc-popover-body': {
        border: '1px solid #E8E8E8',
      },
      '#jtbcustomizer .jtbc-snapshots-list .jtbc-snapshot-item': {
        borderBottom: '1px solid #E8E8E8',
      },
      '#jtbcustomizer .jtbc-snapshots-list .jtbc-snapshot-item:hover': {
        backgroundColor: 'transparent',
      },
      '#jtbcustomizer .jtbc-snapshots-list .jtbc-snapshot-item__remove': {
        textDecoration: 'underline',
        variant: 'text.label',
        fontSize: '12px',
        transition: 'all 0.15s ease-in-out',
      },
      '#jtbcustomizer .jtbc-snapshots-list .jtbc-snapshot-item__remove:hover': {
        textDecoration: 'none',
        transition: 'all 0.15s ease-in-out',
      },
      // snapshot badge
      '#jtbcustomizer .jtbc-button__badge': {
        borderRadius: '50%',
        top: '0px',
        right: '0px',
        pb: '5px',
        ':hover, :focus': {
          backgroundColor: 'red',
        },
      },

      // share modal
      '#jtbcustomizer .jtbc-share-container': {
        pb: '20px',
        mt: '20px',
        borderBottom: '1px solid #E8E8E8',
      },
      '#jtbcustomizer .jtbc-popover-wrapper': {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      },
      '#jtbcustomizer .jtbc-share-popover': {
        minHeight: '180px',
      },
      '#jtbcustomizer .jtbc-share-input': {
        borderRadius: '50px',
        border: '1px solid #C6C6C7',
        height: '44px',
        fontSize: '15px',
      },
      // share modal copy button
      '#jtbcustomizer .jtbc-actions.jtbc-actions__secondary .jtbc-button-container:last-child .jtbc-share-copy-button-container':
        {
          backgroundColor: 'black',
          color: 'white',
          borderRadius: '54px',
          width: '84px',
          height: '44px',
          ml: '8px',
          pl: '0px',
          justifyContent: 'center',
          transition: 'all 0.2s ease-in-out',
          ':hover': {
            bg: 'darkGray',
          },
          '.jtbc-share-copy-button': {
            color: 'white',
            pt: '9px',
            fontSize: '14px',
            ':before, :after': {
              width: '0px',
              heigth: '0px',
            },
          },
        },

      // reset modal
      '#jtbcustomizer .jtbc-modal': {
        border: '1px solid #E8E8E8',
        boxShadow: '0 2px 4px 0 rgba(0,0,0,0.19)',
      },
      '#jtbcustomizer .jtbc-modal-footer': {
        flexDirection: 'row-reverse',
        justifyContent: 'flex-end',
        alignItems: 'center',
        pb: '20px',
        mb: '20px',
        mx: '20px',
        px: 0,
        borderBottom: '1px solid #E8E8E8',
      },
      '#jtbcustomizer .jtbc-modal-footer .jtbc-modal-button.jtbc-modal-button__no':
        {
          backgroundColor: 'transparent',
          height: '34px',
          color: 'text',
          maxWidth: '100px',
          // pl: '40px',
          ml: '0px',
          pt: '10px',
          fontSize: '12px',
          textDecoration: 'underline',
          ':hover': {
            bg: 'transparent',
            textDecoration: 'none',
          },
          ':before, :after': {
            width: '0px',
            heigth: '0px',
          },
        },
      '#jtbcustomizer .jtbc-modal-footer .jtbc-modal-button.jtbc-modal-button__yes':
        {
          backgroundColor: '#222222',
          height: '44px',
          maxWidth: '160px',
          borderRadius: '54px',
          fontSize: '14px',
          ml: 0,
          ':hover': {
            bg: 'darkGray',
          },
          ':before, :after': {
            width: '0px',
            heigth: '0px',
          },
        },

      // text at bottom
      '#jtbcustomizer .jtbc-actions .jtbc-hint.mt-6': {
        minWidth: ['unset !important', '400px !important'],
      },

      // preview panel
      '#jtbcustomizer .jtbc-preview-panel': {
        width: ['100%', '48%'],
      },
      // preview container
      '#jtbcustomizer .jtbc-preview-container': {
        flexWrap: ['wrap', 'nowrap'],
        flexDirection: ['row', 'row-reverse'],
      },
      // actions right
      '#jtbcustomizer .jtbc-actions.jtbc-actions__secondary.jtbc-actions__secondary__desktop':
        {
          display: 'none !important',
        },
      // menu panel actions
      '#jtbcustomizer .jtbc-actions': {
        mt: '0 !important',
      },
      '#jtbcustomizer .jtbc-menu-tab-pane.jtbc-menu-tab-pane--active': {
        mb: '0 !important',
        pb: '0 !important',
      },
      // mobile info wrapper
      '#jtbcustomizer .jtbc-info-wrapper.jtbc-info-wrapper__mobile': {
        display: ['block', 'none'],
        textAlign: 'left',
      },
      // desktop info wrapper
      '#jtbcustomizer .jtbc-info-wrapper.jtbc-info-wrapper__desktop': {
        display: ['none', 'block'],
        padding: '20px',
        py: '0px',
      },
      // thumbnails wrapper
      '#jtbcustomizer .jtbc-thumbnail-wrapper': {
        overflow: 'visible !important',
        flexDirection: ['row', 'column'],
        width: ['100%', '20%'],
        // thumbnails
        '.jtbc-thumbnail-inner': {
          display: ['none', 'flex'],
          flexWrap: 'wrap',
          minHeight: '100px',
          gap: '8px',
          width: '100% !important',
          visibility: 'visible !important',
          // thumbnail
          '.jtbc-product-thumbnail': {
            width: [
              'calc(20% - (4 * 8px / 5)) !important',
              'calc(100% - (4 * 8px / 5)) !important',
            ],
            height: '0px !important',
            pb: [
              'calc(20% - (4 * 8px / 5)) !important',
              'calc(100% - (4 * 8px / 5)) !important',
            ],
            position: 'relative',
            // image
            img: {
              position: 'absolute',
              width: '100%',
              height: '100%',
              top: 0,
              left: 0,
              objectFit: 'contain',
            },
          },
        },
        // thumbnail nav
        '.jtbc-preview-arrow': { display: 'none' },
        // thumbnail pagination
        '.jtbc-thumbnail-indicators': { display: ['flex', 'none'] },
        input: {
          fontSize: '16px !important',
        },
      },
      '#jtbcustomizer .jtbc-thumbnail-wrapper[data-thumbnail-mode="carousel"] .jtbc-product-thumbnail':
        {
          border: '1px solid #E8E8E8',
          transition: 'all 0.15s ease-in-out',
          borderRadius: '4px',
        },
      '#jtbcustomizer .jtbc-thumbnail-wrapper[data-thumbnail-mode="carousel"] .jtbc-product-thumbnail.jtbc-product-thumbnail:hover':
        {
          border: '1px solid #8C8C8D',
          transition: 'all 0.15s ease-in-out',
        },
      '#jtbcustomizer .jtbc-thumbnail-wrapper[data-thumbnail-mode="carousel"] .jtbc-product-thumbnail.jtbc-product-thumbnail--active':
        {
          border: '1px solid #222222',
        },
      '#jtbcustomizer .jtbc-user-content-wrapper .jtbc-user-content-upload-modal .jtbc-modal-container':
        {
          display: ['block', 'flex'],
          top: ['45px', 0],
          bottom: ['24px', 0],
          left: ['8px', 0],
          right: ['8px', 0],
        },
      '#jtbcustomizer .jtbc-user-content-wrapper .jtbc-user-content-upload-modal .jtbc-modal-container .jtbc-modal':
        {
          margin: [0],
          maxHeight: ['none', '100vh'],
        },
      '#jtbcustomizer .jtbc-user-content-wrapper .jtbc-user-content-upload-modal .jtbc-modal-container .jtbc-modal-body':
        {
          paddingLeft: ['12px', '20px'],
          paddingRight: ['12px', '20px'],
        },
      '#jtbcustomizer .jtbc-user-content-wrapper .jtbc-user-content-upload-modal .jtbc-user-content-terms-and-conditions__body':
        {
          maxHeight: 'none',
          overflow: 'visible',
        },
      '#jtbcustomizer .jtbc-user-content-wrapper .jtbc-user-content-upload-modal .jtbc-modal-body .jtbc-modal-content:first-child':
        {
          display: 'flex',
          flexDirection: 'column',
        },
      '#jtbcustomizer .jtbc-user-content-wrapper .jtbc-user-content-upload-modal .jtbc-modal-body .jtbc-modal-content:first-child .jtbc-user-content-choose-file-container':
        {
          order: 1,
        },
      '#jtbcustomizer .jtbc-user-content-wrapper .jtbc-user-content-upload-modal .jtbc-modal-body .jtbc-modal-content:first-child .jtbc-user-content-terms-and-conditions-check':
        {
          order: 0,
        },
      '#jtbcustomizer .jtbc-user-content-wrapper .jtbc-user-content-upload-modal .jtbc-modal-body .jtbc-modal-content:first-child > *':
        {
          order: 2,
        },
    };
  })()
);
